module.exports = window.cb.apricot;